import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { useExplorer } from "@/context/ExplorerContext";
import { ImageSlot } from "@/components/lurio/ImageSlot";
import { CTA, WhatsAppButton } from "@/components/lurio/Primitives";
import { Reveal } from "@/components/lurio/Motion";

export default function FinalCTA() {
  const { t } = useExplorer();
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [reduce ? 0 : 40, reduce ? 0 : -40]);
  const rot = useTransform(scrollYProgress, [0, 1], [reduce ? 3 : 6, reduce ? 3 : 1]);
  return (
    <section id="final" ref={ref} data-testid="section-final-cta" className="relative overflow-hidden bg-blue text-cream">
      <div aria-hidden className="pointer-events-none absolute -end-24 -top-24 h-96 w-96 rounded-full bg-gold/15 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -start-32 bottom-0 h-80 w-80 rounded-full bg-coral/15 blur-3xl" />
      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-32">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] sm:text-5xl lg:text-6xl">
              {t.final.line.map((l, i) => <span key={i} className="block">{l}</span>)}
            </h2>
          </Reveal>
          <Reveal delay={0.08}><p className="mt-6 max-w-md text-[1.08rem] leading-[1.85] text-cream/85 sm:text-lg">{t.final.sub}</p></Reveal>
          <Reveal delay={0.14} className="mt-8 flex flex-wrap items-center gap-3">
            <CTA testId="final-cta-button" />
            <WhatsAppButton testId="final-whatsapp-button" label={t.order.whatsapp} message={t.order.waMessage} className="!border-cream/40 !bg-transparent !text-cream hover:!bg-cream/10" />
          </Reveal>
        </div>
        <motion.div style={{ y, rotate: rot }} className="mx-auto w-full max-w-[300px] lg:col-span-5 lg:max-w-[360px]">
          <div className="rounded-book bg-cream-card p-2 shadow-[0_50px_90px_-40px_rgba(0,0,0,0.6)]">
            <ImageSlot id="cover" rounded="rounded-[12px]" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
